// extracted by mini-css-extract-plugin
module.exports = {"bleed--true":"BUIProvider-module__bleed--true___c7DEv","bleed--0":"BUIProvider-module__bleed--0___0-q5d"};